interface Props {
  value: number
  onChange: (v: number) => void
  /** Phím phụ ở góc trái hàng cuối — thường là "000" khi đang gõ tiền. */
  extraKey?: string
  max?: number
}

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9']

export function NumPad({ value, onChange, extraKey = '000', max = 99_999_999 }: Props) {
  const push = (digits: string) => {
    const next = Number(`${value}${digits}`)
    onChange(Number.isFinite(next) ? Math.min(next, max) : value)
  }

  return (
    <div className="numpad">
      {KEYS.map((k) => (
        <button key={k} type="button" onClick={() => push(k)}>
          {k}
        </button>
      ))}
      <button type="button" onClick={() => push(extraKey)}>
        {extraKey}
      </button>
      <button type="button" onClick={() => push('0')}>
        0
      </button>
      <button
        type="button"
        className="numpad-del"
        onClick={() => onChange(Math.floor(value / 10))}
        aria-label="Xoá số vừa gõ"
      >
        ⌫
      </button>
    </div>
  )
}
